module.exports = __webpack_public_path__ + "media/Akon - Dont Matter.3bf4693e.mp3";